import { render, staticRenderFns } from "./IssueStats.vue?vue&type=template&id=6e414a76&scoped=true"
import script from "./IssueStats.vue?vue&type=script&lang=js"
export * from "./IssueStats.vue?vue&type=script&lang=js"
import style0 from "./IssueStats.vue?vue&type=style&index=0&id=6e414a76&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e414a76",
  null
  
)

export default component.exports